import axios from 'axios'
import config from 'config'

export class TCPAClient {
  constructor(client) {
    this.client = client
  }

  async createConsent(values) {
    const data = { ...values }
    // ActiveProspect wants an array of integer phone numbers; indulge its insanity.
    if (data.phone) {
      // Strip any non-digit characters.
      let phone = data.phone.replace(/[^0-9]/g, '')
      // Trim down to 10 characters, from the end, to remove a country code, if it's present.
      phone = phone.substring(phone.length - 10)
      data.phone = [parseInt(phone, 10)]
    }
    return this.client.post('create', data)
  }
}

export function tcpaFromConfig() {
  return new TCPAClient(axios.create({ baseURL: `${config.tcpaURL}` }))
}
